import Request from '@/utils/request'

export function normalActBaseInfo() {
  return Request({
    url: `/api/v2/app/activity/vltn/home`,
    method: 'get'
  })
}

export function normalActRank() {
  return Request({
    url: `/api/v2/app/activity/vltn/rank`,
    method: 'get'
  })
}

export function normalDaySign() {
  return Request({
    url: `/api/v2/app/activity/vltn/daily/sign`,
    method: 'post'
  })
}

export function normalDayClaim(taskId) {
  return Request({
    url: `/api/v2/app/activity/vltn/daily/claim?taskId=${taskId}`,
    method: 'post'
  })
}

export function normalMilesClaim() {
  return Request({
    url: `/api/v2/app/activity/vltn/milestone/claim`,
    method: 'post'
  })
}
